if (!customElements.get('trexo-setup-configurations')) {
  customElements.define(
    'trexo-setup-configurations',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-sc-controls]').forEach((control) => {
          control.hidden = false;
        });
        this.images = JSON.parse(this.querySelector('[data-sc-images]')?.textContent || '{}');
        this.addEventListener('change', () => this.updateConfiguration());
        this.addEventListener('click', (event) => {
          const familyButton = event.target.closest('[data-sc-family]');
          if (familyButton) this.selectFamily(familyButton.dataset.scFamily);
          const diagram = event.target.closest('[data-sc-zoom]');
          if (diagram) {
            const dialog = this.querySelector('dialog');
            if (!dialog.showModal) return;
            event.preventDefault();
            const fullImage = this.querySelector('[data-sc-full-image]');
            fullImage.src = diagram.href;
            fullImage.alt = diagram.querySelector('img').alt;
            fullImage.width = Number(diagram.dataset.scWidth);
            fullImage.height = Number(diagram.dataset.scHeight);
            this.querySelector('[data-sc-dialog-title]').textContent = diagram.dataset.scTitle || fullImage.alt;
            dialog.showModal();
            this.querySelector('.sc-dialog-scroll').scrollTop = 0;
            this.querySelector('.sc-dialog-scroll').scrollLeft = 0;
          }
        });
        const dialog = this.querySelector('dialog');
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        if (this.dataset.family === 'all') this.selectFamily('slidekit');
        this.updateConfiguration();
      }
      selectFamily(family) {
        this.querySelectorAll('[data-sc-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.scPanel !== family;
        });
        this.querySelectorAll('[data-sc-family]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.scFamily === family));
        });
      }
      updateConfiguration() {
        const selectedModule = this.querySelector('.sc-options:not(.sc-mode-options) input:checked');
        if (!selectedModule) return;
        const configuration = selectedModule.value;
        const available = this.images[configuration];
        const modeInputs = this.querySelectorAll('.sc-mode-options input');
        modeInputs.forEach((input) => {
          input.disabled = !available[input.value];
        });
        let selectedMode = this.querySelector('.sc-mode-options input:checked');
        if (selectedMode.disabled) {
          selectedMode = this.querySelector('.sc-mode-options input[value="wireless"]');
          selectedMode.checked = true;
        }
        const mode = selectedMode.value;
        const labels = {
          only: 'SlideKit',
          slidebase: 'SlideKit + SlideBase',
          lift: 'SlideKit + SlideBase + Lift',
          bridge: 'SlideKit + SlideBase + Lift + Bridge',
        };
        const render = this.querySelector('[data-sc-render]');
        render.src = available[mode];
        render.alt = `${labels[configuration]} · ${mode}`;
        this.querySelector('[data-sc-mode-label]').textContent = mode.toUpperCase();
        this.querySelector('[data-sc-caption]').textContent = labels[configuration];
      }
    },
  );
}
